import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'operationType'
})
export class OperationTypePipe implements PipeTransform {

  transform(value: string): string | null {
    switch(value) {
      case 'sale':
        return 'Venta';
      case 'refund':
        return 'Devolución';
    }
    return value;
  }
}